import script from "./KIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./KIcon.vue?vue&type=script&setup=true&lang=ts"

import "./KIcon.vue?vue&type=style&index=0&id=1ac5eeab&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ac5eeab"]])

export default __exports__